import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { GalaxyFilterValueInterface } from '../interface';


@Component({
  selector: 'glxy-no-input-filter-input',
  template: ``,
  providers: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class GalaxyNoInputFilterInputComponent {
  @Input() set initialValue(_: GalaxyFilterValueInterface[]) {
    this.valueChanges.emit([]);
  }
  @Output() valueChanges = new EventEmitter<GalaxyFilterValueInterface[]>();
}
